<div class="page-banner">
  <div class="page-banner-image"></div>

  <div class="page-banner-overlay">
    <h1 class="banner-title">UPSprint</h1>
    <h3 class="banner-subtitle">Sistema de priorização de demandas</h3>
  </div>
</div>
